import { Paper, styled } from '@mui/material'
import { Cancel, CheckCircle, Info, Help, RemoveCircle } from '@mui/icons-material'
import { PALETTE_DICTIONARY } from '../Theme/Theme.utils'

export const Root = styled(Paper)`
  &.MuiPaper-root {
    align-items: center;
    background-color: ${({ color, theme }) => theme.palette[PALETTE_DICTIONARY[color]][90]};
    color: ${({ color, theme }) =>
      theme.palette[PALETTE_DICTIONARY[color]][color === 'warning' || color === 'orange' ? 35 : 50]};
    display: flex;
    font-family: ${props => props.theme.typography.fontFamily};
    height: 32px;
    letter-spacing: 1.12px;
    margin: ${props => props.margin};
    padding: ${props => props.padding};

    .MuiSvgIcon-root {
      color: inherit;
      height: 16px;
      padding-right: 5px;
      width: auto;
    }
  }
`

export const Span = styled('span')`
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  text-align: center;
  text-transform: uppercase;
`

export const SuccessIcon = styled(CheckCircle)``

export const ErrorIcon = styled(Cancel)``

export const InfoIcon = styled(Info)``

export const WarningIcon = styled(Help)``

export const DefaultIcon = styled(RemoveCircle)``
